// Set defaults to staging/development environment values
const defaultEnvVars = {
  idApiUrl: "https://identity-management.nonprod.vibe.justworks.com",
  oktaAppClientId: "0oa8oxna21NsrdoDh1d7",
  oktaHostUrl: "https://staging-login.justworks.com",
  rollbarPostClientToken: "aa87f7f4e1b1428cab601163ad53773d",
  heapKey: "4002302631",
  heapLocalstorage: true,
  oktaTestingJwGroupId: "00g6nraj8i0AbtoS11d7",
  oktaCommonJwGroupId: "00g6a2n9bqFDuD5Od1d7",
};

export default defaultEnvVars;
